var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-resource", style: _vm.cssVars }, [
    _c("div", { staticClass: "mobile-section-title" }, [_vm._v("资源")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mobile-resource__list" },
      _vm._l(_vm.resourceList, function (item, index) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "mobile-resource__item",
            style: { backgroundImage: "url(" + _vm.getBgImg(item.id) + ")" },
            on: {
              click: function ($event) {
                return _vm.handleClick(item)
              },
            },
          },
          [
            _c("div", { staticClass: "mobile-resource__mask" }),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-resource__content" }, [
              _c("div", { staticClass: "mobile-resource__num" }, [
                _vm._v(_vm._s(item.count)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mobile-resource__name" }, [
                _vm._v(_vm._s(item.name)),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }